import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import RoundedModal from '@components/roundedModal/roundedModal';
import useTranslation from '@hooks/useTranslation';
import { selectCheckoutVisible, closeCheckoutModalAction, selectCheckoutLoading, selectCheckoutStep, selectCheckoutTiers } from '@src/app/reducers/checkout/checkoutSlice';
import { fetchTiersThunk } from '@src/app/reducers/checkout/fetchTiersReducer';
import PricingDisplay from './PricingDisplay';
import PricingDisplaySkeleton from './PricingDisplaySkeleton/PricingDisplaySkeleton';
import SuccessView from './SuccessView';

/**
 * Displays the pricing and manages the checkout flow within a modal.
 * Loads tiers when opened, allows user to dismiss when idle.
 * @returns React.JSX.Element
 */
const CheckoutModal = () => {
  const t = useTranslation('Checkout.Modal');
  const dispatch = useDispatch();
  const visible = useSelector(selectCheckoutVisible);
  const loading = useSelector(selectCheckoutLoading);
  const step = useSelector(selectCheckoutStep);
  const tiers = useSelector(selectCheckoutTiers);
  const [successMode, setSuccessMode] = useState(false);
  
  const isSuccess = step === 'success';

  const handleClose = useCallback(() => {
    setSuccessMode(false);
  }, [dispatch, successMode]);

  useEffect(() => {
    if (visible) {
      // Load tiers on open
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (dispatch as any)(fetchTiersThunk());
    }
  }, [visible, dispatch]);


  useEffect(() => {
    if (step === 'success') {
      setSuccessMode(true);
    }
  }, [step]);

  return (
    <RoundedModal
      title={t('Title')}
      visible={visible}
      noMask={false}
      onAfterClosed={handleClose}
      onCancel={() => dispatch(closeCheckoutModalAction())}
      width={ successMode ? 550 : {
        xs: '90%',
        sm: '80%',
        md: '70%',
        lg: '70%',
        xl: '80%',
        xxl: '1520px',
      }}
      closable={!loading}
      closeOnMaskClick={!loading}
      loading={loading}
      noFooter
      centered
    >
      <div style={{ padding: 24 }}>
        {step === 'pricing' && (
          tiers.length > 0 ? <PricingDisplay /> : <PricingDisplaySkeleton />
        )}

        {isSuccess && <SuccessView />}
      </div>
    </RoundedModal>
  );
};

export default CheckoutModal;


